import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import InvisibleGame from "@/pages/InvisibleGame";
import { Toaster } from "@/components/ui/sonner";

// Hidden QR-code route — redirects to the Member Portal (not linked anywhere)
const JoinRedirect = () => {
  useEffect(() => {
    window.location.replace("https://darling-fox-6bb6ea.netlify.app");
  }, []);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<InvisibleGame />} />
          <Route path="/join" element={<JoinRedirect />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-center" />
    </div>
  );
}

export default App;
